import { Redirect } from 'react-router-dom';
import JwtManager from 'lib/JwtManager';
import { LoadingOverlay } from '@airtm/airtm-ui';
import { LOCAL_STORAGE } from '@constants';
import InvitationContainer, { extractCode } from './InvitationContainer';

type InvitationProps = {
  t: (key: string, params?: any) => string;
  loading: boolean;
  match: object;
  matchingPeer: {
    name: string;
  };
  referrerEmail: string;
};

const Invitation = function ({ t, loading, match, matchingPeer, referrerEmail }: InvitationProps) {
  if (loading) {
    return <LoadingOverlay />;
  }

  const code = extractCode(match);

  let referrerAlert;
  if (!referrerEmail) {
    referrerAlert = {
      title: t('REFERRALS:ALERT_ACCEPT_INVITER_TITLE_FAILED'),
      message: t('REFERRALS:ALERT_ACCEPT_INVITER_TEXT_FAILED', { email: code }),
      type: 'error',
    };
  } else if (referrerEmail) {
    localStorage.setItem(LOCAL_STORAGE.REFERRER_EMAIL, referrerEmail);
    if (!JwtManager.jwt) {
      referrerAlert = {
        title: t('REFERRALS:ALERT_ACCEPT_INVITER_TITLE'),
        message: t('REFERRALS:ALERT_ACCEPT_INVITER_TEXT', { email: matchingPeer.name }),
        type: 'success',
      };
    }
  }

  return (
    <Redirect
      to={{
        pathname: '/sign-up',
        state: { skipAppBanner: true, referrerAlert },
      }}
    />
  );
};

export default InvitationContainer(Invitation);
